require('initializers/gettext').default(__TRANSLATIONS__.gettext.pt); // eslint-disable-line no-undef
require('initializers/i18n').default('pt', __TRANSLATIONS__.i18n.pt); // eslint-disable-line no-undef

require('locales/dependencies');

require('select2/dist/js/i18n/pt');
require('jquery-ui/ui/i18n/datepicker-pt');
require('dayjs/locale/pt');
